import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import {
  Card,
  CardContent,
  Typography,
  Button,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";
import StarSharp from "@mui/icons-material/StarSharp";
import StarRating from "../Tools/StarRating";
import { addReview } from "../../State/Reviews/Action";
import AppPagination from "../Tools/AppPagination";
import { getCarWashByCustomer } from "../../State/Wash/Action";
import { getWashTypeLabel } from "../../constants/washTypes";

export default function Review() {
  const [review, setReview] = useState("");
  const [ratingTemp, setRating] = useState(3);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedBookingId, setSelectedBookingId] = useState(null);
  const [washId, setWashId] = useState(null);
  const dispatch = useDispatch();
  const { wash } = useSelector((store) => store);
  const [page, setPage] = useState(0);

  useEffect(() => {
    dispatch(getCarWashByCustomer(`?page=${page}`));
  }, [dispatch, page]);

  useEffect(() => {
    if (wash?.pagedWash?.ratings) {
      const unreviewedWash = wash.pagedWash.ratings.find(
        (wash) => !wash.rating
      );
      if (unreviewedWash) {
        setSelectedBookingId(unreviewedWash.bookingId);
        setWashId(unreviewedWash.washId);
        setDialogOpen(true);
      }
    }
  }, [wash]);

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setReview("");
    setRating(3);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (review.trim() === "") return;

    const reviewData = {
      rating: ratingTemp + 1,
      review,
      bookingId: selectedBookingId,
      washId,
    };
    dispatch(addReview(reviewData)).then(() => {
      dispatch(getCarWashByCustomer(`?page=${page}`));
      handleCloseDialog();
    });
  };

  return (
    <div className="mx-auto w-full p-4">
      <div className="text-2xl font-bold text-gray-800 bg-blue-200 px-6 py-3 rounded-lg shadow-md text-center mx-auto w-fit">
        Ratings
      </div>

      <Grid container spacing={3}>
        {wash?.pagedWash?.ratings?.map((ratingItem) => (
          <Grid item xs={12} sm={6} md={4} key={ratingItem.bookingId}>
            <Card className="shadow-lg border rounded-lg p-3">
              <CardContent>
                <Typography variant="h6" color="primary">
                  Booking ID: {ratingItem.bookingId}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  <strong>Vehicle:</strong> {ratingItem.vehicle}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  <strong>Wash Type:</strong>{" "}
                  {getWashTypeLabel(ratingItem.washType)}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  <strong>Completed At:</strong>{" "}
                  {moment(ratingItem.scheduledAt).format("lll")}
                </Typography>
                <Typography
                  variant="body2"
                  color="textSecondary"
                  className="mt-2"
                >
                  <strong>Review:</strong>{" "}
                  {ratingItem?.review || "No review yet"}
                </Typography>
                <div className="mt-2">
                  {ratingItem.rating ? (
                    <StarRating rating={ratingItem.rating} />
                  ) : (
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      onClick={() => {
                        setSelectedBookingId(ratingItem.bookingId);
                        setDialogOpen(true);
                      }}
                    >
                      Add Rating
                    </Button>
                  )}
                </div>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <AppPagination
        setPage={setPage}
        totalPages={wash.pagedWash?.totalPages}
      />

      {/* Rating & Review Dialog */}
      <Dialog open={dialogOpen} onClose={handleCloseDialog}>
        <DialogTitle>Rate Your Car Wash</DialogTitle>
        <DialogContent>
          <div className="flex items-center mb-3">
            {[...Array(5)].map((_, i) => (
              <StarSharp
                key={i}
                sx={{
                  fontSize: 30,
                  cursor: "pointer",
                  color: i < ratingTemp + 1 ? "gold" : "gray",
                }}
                onClick={() => setRating(i)}
              />
            ))}
          </div>
          <TextField
            label="Write a Review"
            fullWidth
            multiline
            rows={3}
            value={review}
            onChange={(e) => setReview(e.target.value)}
            variant="outlined"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleSubmit} color="primary" variant="contained">
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
